import {
  PatientSurveyResponseProps,
  SurveyComponentTypes
} from '../../types';

export const getSortedComponents =(data: PatientSurveyResponseProps) => {
  const childComponents = {};
  data.filter((item) => !!item.parentId)
      .map((item) => {
        if (childComponents[item.parentId]) {
          childComponents[item.parentId].push(item);
        } else {
          childComponents[item.parentId] = [item];
        }
      });

  const components =
  data.filter((item) => !item.parentId)
      .sort((item1, item2) => item1.seqNum - item2.seqNum);

  const [headerComponent] = components.splice(components.findIndex(
      ({type}) => type === SurveyComponentTypes.HEADER
  ), 1);

  Object.keys(childComponents).map((item) => {
    childComponents[item].sort((item1, item2) => item1.seqNum - item2.seqNum);
    const parent = components.find((component) => component.id === +item);

    if (parent) {
      parent.children = childComponents[item];
    }
  });

  return {headerComponent, components};
};
